export const PROFILE_SNOOZE_HOURS_DEFAULT = 5;
export const PROFILE_SNOOZE_MAX_HOURS = 24; // safety cap

const storageKeyForUser = (userId: string): string => `smd_profile_snooze_until_${userId}`;

type SnoozeRecord = {
    v: number;
    until: number; // epoch ms
};

export function getProfileSnoozeUntil(userId: string): number | null {
    try {
        const raw = localStorage.getItem(storageKeyForUser(userId));
        if (!raw) return null;
        const parsed = JSON.parse(raw) as SnoozeRecord | null;
        if (!parsed || typeof parsed.until !== 'number') return null;

        const now = Date.now();
        const maxFuture = now + PROFILE_SNOOZE_MAX_HOURS * 60 * 60 * 1000;
        if (parsed.until <= 0 || parsed.until > maxFuture) {
            return null;
        }
        return parsed.until;
    } catch {
        return null;
    }
}

export function setProfileSnoozeHours(userId: string, hours: number): void {
    const clampedHours = Math.min(Math.max(hours, 0), PROFILE_SNOOZE_MAX_HOURS);
    const until = Date.now() + clampedHours * 60 * 60 * 1000;
    const record: SnoozeRecord = { v: 1, until };
    try {
        localStorage.setItem(storageKeyForUser(userId), JSON.stringify(record));
    } catch {
        // ignore storage errors
    }
}

export function clearProfileSnooze(userId: string): void {
    try {
        localStorage.removeItem(storageKeyForUser(userId));
    } catch {
        // ignore
    }
}


